import { render } from "./AccountsCreate.vue?vue&type=template&id=f73434b4"
import script from "./AccountsCreate.vue?vue&type=script&lang=js"
export * from "./AccountsCreate.vue?vue&type=script&lang=js"
script.render = render

export default script